import React, { ReactNode } from 'react';
import styles from './HeaderBodyBox.module.scss';
import clsx from 'clsx';

interface HeaderBodyBoxProps {
    title: string | ReactNode;
    subHeading?: string;
    headerRight?: ReactNode;
    children: ReactNode;
    className?: string;
    headerClassName?: string;
    bodyClassName?: string;
    isPDFReport?: boolean;
    // Omits the body wrapper entirely (no empty bordered/padded box under the header) — for
    // states where the caller has nothing to render in the body, e.g. a terminal fetch failure.
    hideBody?: boolean;
}

const HeaderBodyBox: React.FC<HeaderBodyBoxProps> = ({
    title,
    subHeading,
    headerRight,
    children,
    className,
    headerClassName,
    bodyClassName,
    isPDFReport = false,
    hideBody = false,
}) => {
    return (
        <div className={clsx(styles.container, { [styles.pdfReport]: isPDFReport }, className)}>
            <div className={clsx(styles.header, headerClassName)}>
                <div className={styles.headerLeft}>
                    <div className={styles.heading}>{title}</div>
                    {subHeading && <h3 className={styles.subHeading}>{subHeading}</h3>}
                </div>
                {headerRight && <div className={styles.headerRight}>{headerRight}</div>}
            </div>
            {!hideBody && (
                <div className={clsx(styles.body, bodyClassName)} data-testid="header-body-box-body">
                    {children}
                </div>
            )}
        </div>
    );
};

export default HeaderBodyBox;
